// extracted by mini-css-extract-plugin
export default {"container":"RiskRangeNumberInputForm_container__HwMIs","label":"RiskRangeNumberInputForm_label__eMVkA","items":"RiskRangeNumberInputForm_items__cXo8S"};